import { imageCoverContainer, imageWrapperPreserveRatio } from '@helpers/aspectRatio';
import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import { Device, until } from '@helpers/media';
import { h5, paragraphSmall } from '@helpers/typography';
import ButtonStyles from '@stories/Components/Buttons/Button/Button.styles';
import { ContentType } from '@stories/Components/Misc/SectionWrapper/SectionWrapper';
import styled from 'styled-components';
const Container = styled.article `
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  color: currentColor;
  text-decoration: none;

  /* Icon colours */
  --iconBackground: ${brand.green.gradient};
  --iconBorder: ${brand.green.default};
  --iconColour: ${brand.global.white};

  &[data-type=${ContentType.Intermediaries}] {
    --iconBackground: ${brand.green.lightGradient};
    --iconBorder: ${brand.green.light};
    --iconColour: ${brand.blue.navy};
  }

  &[data-type=${ContentType.Savings}] {
    --iconBackground: ${brand.blue.gradient};
    --iconBorder: ${brand.blue.default};
    --cardBackground: ${brand.blue.light};
  }

  &[data-align='centre'] {
    align-items: center;
    text-align: center;
  }

  ${ButtonStyles.Container} {
    margin-top: auto;
  }
`;
const ImageWrapper = styled.div `
  ${imageWrapperPreserveRatio(70, 70)};

  width: 70px;
  margin-bottom: 16px;
`;
const Image = styled.img `
  ${imageCoverContainer()};

  object-fit: contain;
`;
const Icon = styled.div `
  ${imageCoverContainer()};

  --direction: 180deg;

  background: var(--iconBackground);
  border: 2px solid var(--iconBorder);
  border-radius: 5000px;
  display: grid;
  place-content: center;

  svg {
    color: var(--iconColour);
    width: 46px;
  }
`;
const Title = styled.h3 `
  ${h5};

  margin: 0;
`;
const Description = styled.p `
  ${paragraphSmall};

  margin: 12px 0 0;

  ${Container}:has(${ButtonStyles.Container}) & {
    margin-bottom: 16px;
  }

  @media ${until(Device.TabletLarge)} {
    ${fonts.proximaNova.medium};
  }
`;
const UspCardStyles = {
    Container,
    ImageWrapper,
    Image,
    Icon,
    Title,
    Description,
};
export default UspCardStyles;
